<template>
    <div class="pdf-preview" ref="preview">
        <div :id="id" class="pdf"></div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            id: uniqid(),
            loaded: false,
        };
    },
    mounted() {
        this.update();
    },
    methods: {
        update() {
            if (this.loaded) {
                let child = document.getElementById(this.id);
                this.$refs.preview.removeChild(child);
                $(this.$refs.preview).append(
                    `<div id="${this.id}" class="pdf"></div>`
                );
            }
            PDFObject.embed(this.url, `#${this.id}`);
            this.loaded = true;
        },
    },
    watch: {
        url() {
            this.update();
        },
    },
};
</script>

<style scoped></style>
